import Vue from 'vue'
import Router from 'vue-router'

// Route components
import HomePage from '@/components/home-page'
import LoginForm from '@/components/login-form'
import AccountPage from '@/components/account-page'
import DevBlog from '@/components/dev-blog'
import PrivacyPolicy from '@/components/privacy-policy'
import TermsOfService from '@/components/terms-of-service'
import Error404 from '@/components/error404'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home-page',
      component: HomePage
    },
    {
      path: '/signin',
      name: 'signin',
      component: LoginForm
    },
    {
      path: '/account',
      name: 'account',
      component: AccountPage
    },
    {
      path: '/devblog',
      name: 'devblog',
      component: DevBlog
    },
    {
      path: '/privacy-policy',
      name: 'privacypolicy',
      component: PrivacyPolicy
    },
    {
      path: '/terms-of-service',
      name: 'termsofservice',
      component: TermsOfService
    },
    {
      path: '/404',
      name: '404',
      component: Error404
    },
    {
      path: '*',
      redirect: '404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js